import { api } from './api';
import { PricingPlan, PricingPlanCreate, PricingPlanUpdate, PricingPlanListResponse } from '../types/pricing';

class AdminPricingService {
  private baseUrl = '/v1/admin';

  async getPricingPlans(params: {
    page?: number;
    per_page?: number;
  } = {}): Promise<PricingPlanListResponse> {
    const searchParams = new URLSearchParams();

    if (params.page) searchParams.append('page', params.page.toString());
    if (params.per_page) searchParams.append('per_page', params.per_page.toString());

    const response = await api.get(`${this.baseUrl}/pricing-plans?${searchParams.toString()}`);
    return response.data;
  }

  async getPricingPlan(planId: number): Promise<PricingPlan> {
    const response = await api.get(`${this.baseUrl}/pricing-plans/${planId}`);
    return response.data;
  }

  async createPricingPlan(planData: PricingPlanCreate): Promise<PricingPlan> {
    const response = await api.post(`${this.baseUrl}/pricing-plans`, planData);
    return response.data;
  }

  async updatePricingPlan(planId: number, planData: PricingPlanUpdate): Promise<PricingPlan> {
    const response = await api.put(`${this.baseUrl}/pricing-plans/${planId}`, planData);
    return response.data;
  }

  async deletePricingPlan(planId: number): Promise<void> {
    await api.delete(`${this.baseUrl}/pricing-plans/${planId}`);
  }

  async getActivePricingPlans(): Promise<PricingPlan[]> {
    const response = await api.get(`${this.baseUrl}/pricing-plans/active`);
    return response.data;
  }

  formatCurrency(amount: number, currency: string = 'USD'): string {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency.toUpperCase()
    }).format(amount / 100);
  }

  getPlanTypeDisplayName(planType: string): string {
    switch (planType) {
      case 'essential':
        return 'Essential';
      case 'gold':
        return 'Gold';
      case 'premium':
        return 'Premium';
      default:
        return planType;
    }
  }

  getPlanTypeBadgeColor(planType: string): string {
    switch (planType) {
      case 'essential':
        return 'bg-blue-100 text-blue-800';
      case 'gold':
        return 'bg-yellow-100 text-yellow-800';
      case 'premium':
        return 'bg-purple-100 text-purple-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  }
}

export const adminPricingService = new AdminPricingService();
